import React from 'react';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {CoreDI, IEventManagerWithAsync, lazyInject, ScreenManager, ScreenParameters} from '@gongxigames/framework/core';
import {CheatErrorsController} from './CheatErrorsController';
import {CheatPluginView} from '../../CheatPluginView';
import {DisplayObjectList} from '../../components/DisplayObjectList';
import {ButtonWithTitle} from '../../components/ButtonWithTitle';

type CheatErrorsViewState = {
    width: number;
    height: number;
};

export class CheatErrorsView extends CheatPluginView<CheatErrorsController, {}, CheatErrorsViewState> {
    @lazyInject(CoreDI.IEventManagerWithAsync)
    protected eventManager!: IEventManagerWithAsync<GlobalEventsMap>;

    @lazyInject(CoreDI.ScreenManager)
    protected fullscreenManager!: ScreenManager;

    constructor(props: {}) {
        super(props as any);

        this.state = {
            width: this.fullscreenManager.getScreenState().width,
            height: this.fullscreenManager.getScreenState().height
        };
    }

    public componentDidMount(): void {
        this.eventManager.on('General.Screen.RESIZED', this.onResized.bind(this), this);
    }

    public componentWillUnmount(): void {
        this.eventManager.off('General.Screen.RESIZED', this);
    }

    protected onResized({width, height}: ScreenParameters): void {
        this.setState({width, height});
    }

    protected getErrorsButtons(): JSX.Element[] {
        const buttons = [];
        const {errors} = this.controller;

        for (const [key, value] of errors) {
            buttons.push(
                <ErrorButton onClick={() => this.controller.show(value)} title={key} key={key} />
            );
        }

        return buttons;
    }

    public render(): JSX.Element {
        return (
            <DisplayObjectList y={80} direction={'column'} gapBetweenChildren={20}>
                <ErrorButton title={'Close error popup'} onClick={() => this.controller.close()} />
                <FlexBoxComponent direction={'row'} gap={20} wrap={true} containerWidth={this.state.width - 500}>
                    {...this.getErrorsButtons()}
                </FlexBoxComponent>
            </DisplayObjectList>
        );
    }
}

function ErrorButton({onClick, title}: any): JSX.Element {
    return <ButtonWithTitle onClick={onClick} title={title} fontSize={50} height={200} width={'auto'}/>;
}
